import { render, staticRenderFns } from "./TabListWithTitles.vue?vue&type=template&id=45e51a06&scoped=true"
import script from "./TabListWithTitles.vue?vue&type=script&lang=js"
export * from "./TabListWithTitles.vue?vue&type=script&lang=js"
import style0 from "./TabListWithTitles.vue?vue&type=style&index=0&id=45e51a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e51a06",
  null
  
)

export default component.exports